import { SET_SESSION_TIMER, SET_SESSION_LENGTH, UPDATE_CURRENT_SESSION } from "../mutation_types";
import { START_TIMER, STOP_TIMER, USER_LOGOUT } from "../action_types";

import router from '@/router.js';


const state = {
    sessionTimer: null,
    sessionLengthMin: 10,
    currentSessionLength: 0,
};

const getters = {
    getSessionTimerRef(state) {
        return state.sessionTimer;
    },
    getCurrentSessionClockFormat(state) {
        
        let sessionLengthMs = state.currentSessionLength;
        let minutes = Math.floor(sessionLengthMs / (60 * 1000));
        let seconds = Math.floor(sessionLengthMs % (60 * 1000)) / 1000;
        
        const paddedString = (time) => {
            return `${time.toString().length === 2 ? `${time}` : `0${time}` }`
        }
        const clockString = `${paddedString(minutes)} : ${paddedString(seconds)}`
        return clockString
    }
};


const mutations = {
    [SET_SESSION_TIMER] (state, payload) {
        state.sessionTimer = payload.sessionTimer
    },
    [SET_SESSION_LENGTH] (state, payload) {
        state.sessionLengthMin = payload.sessionLengthMin
    },
    [UPDATE_CURRENT_SESSION] (state, payload) {
        state.currentSessionLength = payload.nextSessionLength
    }
};

const actions = {
    [START_TIMER]({ commit, state, dispatch }) {
        clearInterval(state.sessionTimer);
        commit({
            type: UPDATE_CURRENT_SESSION,
            nextSessionLength: state.sessionLengthMin * 60 * 1000
        });
        commit({
            type: SET_SESSION_TIMER,
            sessionTimer: setInterval(() => {
                let nextSessionLength = state.currentSessionLength -= 1000;
                if (nextSessionLength <= 0) {
                    nextSessionLength = 0;
                    dispatch({
                        type: STOP_TIMER
                    })
                }
                commit({
                    type: UPDATE_CURRENT_SESSION,
                    nextSessionLength
                });
            }, 1000)
        })
    },
    [STOP_TIMER]({ commit, state, dispatch }) {
        clearInterval(state.sessionTimer);
        commit({
            type: SET_SESSION_TIMER,
            sessionTimer: null
        });
        commit({
            type: UPDATE_CURRENT_SESSION,
            nextSessionLength: 0
        })
        dispatch({
            type: USER_LOGOUT
        })
        router.push({
            name: 'auth-error',
            params: {
                errorCode: 403,
                errorMessage: 'Az időkorlát lejárt.'
            }
        })
    }
};


export default {
    state,
    getters,
    mutations,
    actions
}